import {
  ProjectManagement,
  IProjectManagementActionTypes,
  ITicketManagementActionCreator,
} from "models/IProjectManagementState";

const initialState = {
  alltasks: {},
  pendingtasks: {},
  customerworkhours: [],
  customerworkanalytics: {},
  sessionList: {},
};

const reducer = (
  state = initialState,
  { type, payload }: ITicketManagementActionCreator
) => {
  switch (type) {
    case IProjectManagementActionTypes.FETCH_DAILY_UPDATES_LIST_REQUEST:
      return {
        ...state,
        alltasks: {},
      };
    case IProjectManagementActionTypes.FETCH_DAILY_UPDATES_LIST_SUCCESS:
      return {
        ...state,
        alltasks: {
          ...payload,
        },
      };
    case IProjectManagementActionTypes.FETCH_PENDING_UPDATES_LIST_REQUEST:
      return {
        ...state,
        pendingtasks: {},
      };
    case IProjectManagementActionTypes.FETCH_PENDING_UPDATES_LIST_SUCCESS:
      return {
        ...state,
        pendingtasks: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_CUSTOMER_WISE_WORK_HOURS_REQUEST:
      return {
        ...state,
        customerworkhours: [],
      };
    case IProjectManagementActionTypes.FETCH_CUSTOMER_WISE_WORK_HOURS_SUCCESS:
      return {
        ...state,
        customerworkhours: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_PROJECT_WISE_WORK_HOURS_REQUEST:
      return {
        ...state,
        projectworkhours: [],
      };
    case IProjectManagementActionTypes.FETCH_PROJECT_WISE_WORK_HOURS_SUCCESS:
      return {
        ...state,
        projectworkhours: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_TEAM_WISE_WORK_HOURS_REQUEST:
      return {
        ...state,
        teamworkhours: [],
      };
    case IProjectManagementActionTypes.FETCH_TEAM_WISE_WORK_HOURS_SUCCESS:
      return {
        ...state,
        teamworkhours: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_CUSTOMER_WORK_ANALYSIS_REQUEST:
      return {
        ...state,
        customerworkanalytics: {},
      };
    case IProjectManagementActionTypes.FETCH_CUSTOMER_WORK_ANALYSIS_SUCCESS:
      return {
        ...state,
        customerworkanalytics: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_PROJECT_WORK_ANALYSIS_REQUEST:
      return {
        ...state,
        projectworkanalytics: {},
      };
    case IProjectManagementActionTypes.FETCH_PROJECT_WORK_ANALYSIS_SUCCESS:
      return {
        ...state,
        projectworkanalytics: {
          ...payload,
        },
      };

    case IProjectManagementActionTypes.FETCH_TEAM_WORK_ANALYSIS_REQUEST:
      return {
        ...state,
        teamworkanalytics: {},
      };
    case IProjectManagementActionTypes.FETCH_TEAM_WORK_ANALYSIS_SUCCESS:
      return {
        ...state,
        teamworkanalytics: {
          ...payload,
        },
      };
    case IProjectManagementActionTypes.FETCH_EMPLOYEE_WORK_ANALYSIS_REQUEST:
      return {
        ...state,
        employeeworkanalytics: {},
      };
    case IProjectManagementActionTypes.FETCH_EMPLOYEE_WORK_ANALYSIS_SUCCESS:
      return {
        ...state,
        employeeworkanalytics: {
          ...payload,
        },
      };
    case IProjectManagementActionTypes.FECTH_SESSIONS_LIST_REQUEST:
      return {
        ...state,
        sessionList: {},
      };
    case IProjectManagementActionTypes.FECTH_SESSIONS_LIST_SUCCESS:
      return {
        ...state,
        sessionList: {
          ...payload.data,
        },
      };
    default:
      return state;
  }
};

export default reducer;
